<template>
  <div id="home">
    <!-- BANNER CONTACTO-->
    <div class="diagnostic-alerts" v-if="market === 'ES'">
      <div class="box contact-support">
        <div class="meta">
          <div class="description">
            <p>{{ $t("views.home.contact_support") }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- VIDEO ADV -->
    <div v-if="Object.keys(videoAdv).length > 0 && !hidePopup" class="popup">
      <div class="video">
        <iframe
          v-if="videoAdv.url.includes('youtube')"
          class="player"
          rel="0"
          :src="
            videoParse() +
              '?&autoplay=1&rel=0&modestbranding=1&autohide=1&showinfo=0&color=white&controls=0&modestbranding=1&rel=0'
          "
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          iv_load_policy="3"
        ></iframe>
        <iframe
          v-else-if="videoAdv.url.includes('vimeo')"
          class="player"
          :src="
            videoParse() + '?autoplay=1&title=0&byline=0&portrait=0&sidedock=0'
          "
          frameborder="0"
          allowfullscreen
        ></iframe>
        <video
          class="player"
          autoplay
          :src="videoAdv.url"
          v-else
          controls
        ></video>
        <div class="buttons">
          <div class="button" @click="history(videoAdv.id)">
            {{ $t("views.home.no_more") }}
          </div>
          <div class="button active" @click="hidePopup = true">
            {{ $t("views.home.show_later") }}
          </div>
        </div>
      </div>
    </div>

    <!-- DIAGNOSTIC ALERTS -->
    <div
      v-if="market === 'ES' && !Object.values(diagnosticAlerts).every(v => v === true)"
      class="diagnostic-alerts"
    >
      <div class="sec-title">{{ $t("views.home.alerts.title") }}</div>
      <div class="box" @click="goTo('diagnostic')">
        <div class="meta">
          <div class="label">{{ $t("views.home.alerts.diagnostic") }}</div>
          <div class="description">
            {{ $t("views.home.alerts.description") }}
          </div>
          <div class="tools">
            <div class="tool" :class="{ done: diagnosticAlerts['env'] }">
              {{ $t("views.home.alerts.environment") }}
            </div>
            <div class="tool" :class="{ done: diagnosticAlerts['cluster'] }">
              {{ $t("views.home.alerts.clients") }}
            </div>
            <div class="tool" :class="{ done: diagnosticAlerts['competence'] }">
              {{ $t("views.home.alerts.competence") }}
            </div>
            <div class="tool" :class="{ done: diagnosticAlerts['dafo'] }">
              {{ $t("views.home.alerts.dafo") }}
            </div>
          </div>
        </div>
        <div class="action"></div>
      </div>
    </div>

    <!-- SLIDER -->
    <div id="slider">
      <Slider></Slider>

      <!--<div v-for="(item, index) in sliders" class="item" :key="item.id">
        <a :href="item.action"><img :src="item.img" /></a>

      </div>-->
    </div>

    <!-- MY LOCAL ACTIONS -->
    <div class="local-actions" v-if="market === 'ES'">
      <div class="sec-title">{{ $t("views.home.local_actions.title") }}</div>

      <template v-if="Object.keys(localActions).length == 0">
        <div class="empty">
          <div class="meta">
            <div class="label">{{ $t("views.home.local_actions.empty") }}</div>
            <div class="description">
              {{ $t("views.home.local_actions.create") }}
            </div>
          </div>

          <div class="btn" @click="goTo('marketing')">
            {{ $t("views.home.local_actions.create_new") }}
          </div>
        </div>
      </template>

      <template v-else>
        <div class="action" v-for="action in localActions">
          <template v-if="dateCheck(action.start_date, action.end_date)">
            <div class="when now">
              {{ $t("views.home.local_actions.actual") }}
            </div>
          </template>
          <template v-else>
            <div class="when soon">
              {{ $t("views.home.local_actions.soon") }}
            </div>
          </template>

          <div class="meta">
            <div class="name">{{ action.name }}</div>
            <div class="date">
              {{ $t("views.home.local_actions.date", { start: humanizeDate(action.start_date), end: humanizeDate(action.end_date), year: action.year }) }}
            </div>
          </div>
          <div class="buttons">
            <div
              class="btn"
              @click="
                search(
                  action.section_type ? action.section_type : action.name,
                  action.section_url
                )
              "
            >
              {{ $t("views.home.local_actions.search") }}
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- NEW FILES -->
    <div class="news">
      <div class="sec-title">{{ $t("views.home.files") }}</div>
      <FileList :type="'new'"></FileList>
    </div>

    <div class="bg"></div>
  </div>
</template>

<script>
import Slider from "@/components/domain/home/Slider";
import FileList from "@/components/domain/files/FileList";

export default {
  name: "Home",
  components: { Slider, FileList },
  data() {
    return {
      hidePopup: false
    };
  },
  computed: {
    videoAdv() {
      return this.$store.getters["sliders/getVideoAdv"];
    },

    selectedLocation() {
      return this.$store.getters["locations/getSelectedLocation"];
    },

    diagnosticAlerts() {
      return this.$store.getters["sliders/getDiagnosticAlerts"];
    },

    localActions() {
      return this.$store.getters["sliders/getLocalActions"];
    },

    market() {
      return this.$store.getters.getMarket;
    }
  },
  created() {
    window.scroll({
      top: 0,
      behavior: "smooth"
    });

    var self = this;
    if (this.market == 'ES') {
      this.$store.commit("setTitle", "LSM");
    } else {
      this.$store.commit("setTitle", "LRM");
    }
    this.$store.commit("setMenuVisible", true);
    this.$overlay.loading();

    Promise.all([
      this.$store.dispatch("files/loadNewFiles"),
      this.$store.dispatch("sliders/loadDiagnosticAlerts", this.selectedLocation.id),
      this.$store.dispatch("sliders/loadLocalActions", this.selectedLocation.id),
      this.$store.dispatch("sliders/loadVideoAdv")
    ]).then(function() {
      self.$overlay.hide();
    }).catch(function(error) {
      console.error('Error loading home data:', error);
      self.$overlay.hide();
    });
  },
  methods: {
    goTo(path) {
      this.$router.push("/" + path);
    },

    search(value, section_url) {
      if (section_url) {
        this.$router.push(
          (parseInt(value) == 1
            ? "nacional"
            : parseInt(value) == 2
            ? "local"
            : "comunicacion") +
            "/" +
            section_url
        );
      } else {
        this.$router.push({ name: "search", query: { s: value } });
      }
    },

    //   LOCAL ACTION METHODS
    dateCheck(start, end) {
      var startDate = Date.parse(start);
      var endDate = Date.parse(end);
      var currentDate = Date.now();

      if (currentDate <= endDate && currentDate >= startDate) {
        return true;
      }
      return false;
    },

    humanizeDate(date) {
      return moment(date.replace("/", "/01/")).format("DD [de] MMMM");
    },

    videoParse() {
      if (
        this.videoAdv &&
        (typeof localStorage.getItem("videoAdv") == "undefined" ||
          this.videoAdv.id != localStorage.getItem("videoAdv"))
      ) {
        if (this.videoAdv.url.includes("youtube")) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = this.videoAdv.url.match(regExp);
          var videoID = match && match[2].length === 11 ? match[2] : null;

          return "https://www.youtube-nocookie.com/embed/" + videoID;
        } else if (this.videoAdv.url.includes("vimeo")) {
          var regExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
          var match = this.videoAdv.url.match(regExp);

          return "https://player.vimeo.com/video/" + match[3];
        }
        return "";
      } else {
        this.hidePopup = true;
      }
    },

    history(id) {
      localStorage.setItem("videoAdv", id);
      this.hidePopup = true;
    }
  },

  beforeRouteLeave(to, from, next) {
    window.scroll({
      top: 0,
      behavior: "smooth"
    });
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#home {
  .popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 50;
    background-color: rgba($color: #000, $alpha: 0.6);

    .video {
      top: calc((100vh - (56.25vw / 2)) / 2 - 35px);
      left: calc((100vw / 2) / 2);
      width: calc(100vw / 2);
      height: calc(56.25vw / 2);
      margin: 0 auto;
      position: fixed;

      .player {
        border-radius: 6px 6px 0 0;
        width: 100%;
        height: 100%;
        width: -webkit-fill-available;
        margin: 0 auto;
        border: 0;
        z-index: 9999999999;

        &:focus {
          border: 0;
          outline: none;
        }
      }
      .buttons {
        border-radius: 0 0 3px 3px;
        height: 60px;
        padding: 7px 10px;
        width: 100%;
        margin: 0 auto;
        background-color: #fff;
        z-index: 51;
        position: relative;
        top: -6px;
        text-align: right;
        overflow: hidden;

        .button {
          display: inline-block;
          padding: 10px 40px;
          background-color: #ccc;
          border-radius: 3px;
          margin: 0 10px;
          font-size: 16px;
          //   color: #fff;
          text-align: center;
          max-width: calc(50% - 20px);
          max-height: 50px;
          vertical-align: middle;
          cursor: pointer;

          &.active {
            background-color: #ffbb0c;
          }
        }
      }
    }
  }

  .diagnostic-alerts {
    background-color: #eeeeee;
    border-radius: 10px;
    padding: 13px 20px 20px;
    margin: 50px auto;
    width: 60%;

    .sec-title {
      color: #000;
      font-weight: bold;
      text-align: left;
      line-height: 25px;
      padding-left: 30px;
      margin-bottom: 10px;
      font-size: 17px;
      background-image: url("/img/alert.svg");
      background-repeat: no-repeat;
      background-position: left 15px center;
      padding-left: 45px;
      background-size: 20px;
    }

    .box {
      background-color: #fff;
      border-radius: 6px;
      border-left: 5px solid #ffbb0c;
      padding: 10px 20px;
      cursor: pointer;

      &.contact-support {
        width: 100%;
        display: flex;
        align-items: left;
        justify-content: center;
        
        .meta {
          width: 100%;
          text-align: left;
          height: auto;
          margin-top: 8px;
          margin-bottom: 8px;
          p {
            margin: 0;
            color: #222222;
          }
        }
      }

      .meta {
        display: inline-flex;
        width: calc(100% - 100px);
        flex-direction: column;
        align-content: flex-start;
        align-items: flex-start;
        justify-content: center;

        .label {
          font-size: 22px;
          color: #000;
          font-family: Speedee-Bold;
          line-height: 30px;
        }

        .description {
          font-size: 16px;
          font-family: Speedee;
          margin-bottom: 5px;
        }

        .tools {
          display: inline-flex;

          .tool {
            cursor: pointer;
            background-color: transparent !important;
            padding-right: 30px;
            background-image: url("/img/no-done.svg");
            background-repeat: no-repeat;
            background-position: right 5px center;
            background-size: 18px;
            margin-right: 35px;
            color: #8a8a8a;

            &.done {
              background-image: url("/img/done.svg");
            }
          }
        }
      }
      .action {
        display: inline-flex;
        width: 100px;
        height: 80px;
        background-image: url("/img/right_grey.svg");
        background-repeat: no-repeat;
        background-position: right center;
        background-size: 20px;
        align-content: center;
        justify-content: center;
        align-items: flex-start;
        float: right;
      }
    }
  }

  #slider {
    margin: 0 auto;
    margin-top: 50px;
    width: 100%;
    max-width: 1000px;
    margin-bottom: 50px;
  }

  .local-actions {
    width: 60%;
    margin: 15px auto 70px;

    .sec-title {
      background: var(--main_color);
      color: var(--dark_color);
      display: inline-block;
      text-align: center;
      font-size: 22px;
      font-family: Speedee-Bold;
      margin: 15px 0;
      padding: 0px 10px;
      margin-bottom: 10px;
      background-image: url("/img/calendar.svg");
      background-repeat: no-repeat;
      background-position: left 15px center;
      padding-left: 45px;
      background-size: 18px;
    }

    .btn {
      cursor: pointer;
      font-size: 16px;
      background-color: var(--secondary_color);
      color: white;
      padding: 13px 25px;
      border-radius: 6px;
      width: fit-content;
      font-family: Speedee;
      margin: 0 auto;
    }

    .empty {
      .meta {
        text-align: center;
        margin: 20px auto;

        .label {
          font-size: 22px;
          color: #000;
          font-family: Speedee-Bold;
          line-height: 40px;
        }

        .description {
          font-size: 18px;
          font-family: Speedee;
        }
      }
    }

    .action {
      background-color: #e5e5e5;
      width: 100%;
      margin: 25px auto;
      height: auto;
      overflow: visible;
      position: relative;
      border-radius: 6px;
      padding: 15px 20px;
      display: flex;
      align-content: center;
      align-items: center;

      .when {
        position: absolute;
        top: -10px;
        left: 0;
        height: auto;
        font-size: 13px;
        color: #fff;
        width: 150px;
        border-radius: 6px;
        line-height: 22px;
        font-family: Speedee-Bold;

        &.now {
          background-color: var(--main_color);
        }

        &.soon {
          background-color: #000;
        }
      }

      .meta {
        text-align: left;
        width: calc(100% - 170px);
        display: inline-flex;
        flex-direction: column;
        align-content: flex-start;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: nowrap;
        // float: left;

        .name {
          font-size: 24px;
          font-family: Speedee-Bold;
          color: #000;
        }

        .date {
          font-family: Speedee;
          font-size: 15px;
        }
      }
      .buttons {
        width: 170px;
        text-align: right;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
        align-content: center;
      }
    }
  }

  .news {
    margin: 0 auto;
    width: 90%;

    .sec-title {
      background: var(--main_color);
      color: var(--dark_color);
      display: inline-block;
      text-align: center;
      font-size: 22px;
      font-family: Speedee-Bold;
      margin: 15px 0;
      padding: 0px 10px;
      margin-bottom: 10px;
      z-index: 1;
    }
  }

  .bg {
    position: fixed;
    bottom: 0;
    left: 0;
    background: url("/img/bg4.png");
    background-position: center bottom 0px;
    background-repeat: repeat-x;
    background-size: 600px;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
